import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import schedule from "../../../Assets/Projects/mobile/Roster.png";

function SmartClassSchedule() {
  return (
    <ProjectDetailCard
      title="Smart Class Schedule System"
      image={schedule}
      screenshots={[schedule, schedule, schedule]}
      description="
      Smart Class Schedule System is a mobile application developed to simplify academic scheduling for both students and teachers. The application allows students to access their daily class schedules, while teachers can view their teaching assignments based on subjects, classrooms, and schedules. With an intuitive interface and centralized schedule management, the system improves communication, minimizes scheduling conflicts, and provides quick access to academic timetable information anytime and anywhere.
      "
      technologies={[
        "Flutter",
        "Dart",
        "Firebase",
        "Cloud Firestore",
        "Firebase Authentication",
        "Android Studio",
        "Material Design",
        "REST API",
        "Git",
        "Mobile Development",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          {/* <img src={schedule} alt="gallery1" />
          <img src={schedule} alt="gallery2" />
          <img src={schedule} alt="gallery3" /> */}
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default SmartClassSchedule;
